<div fxFlexFill fxLayout="column" fxLayoutAlign="start stretch">
  <!-- <div class="inner">
    <h1 align="center">Welcome to the Dual Enrollment: Link to Advisors (DELTA) Site!</h1>
    <div class="infoblock" fxHide fxShow.gt-sm>
      <p>The Dual Enrollment Link to Advisors (DELTA) System is a product of the Polk County School District and is intended to serve as a portal for the creation, processing, and
        management of dual enrollment course requests for all students in the Polk County School District. Please log in to the system using your usual login credentials.</p>
    </div>
  </div> -->
  <div fxFlex fxLayout="row" fxLayoutAlign="space-around start" fxLayoutGap="30px" fxLayout.lt-md="column" fxLayoutAlign.lt-md="start start">
    <!-- Issue Alerts (if any) - Large width -->
    <div fxShow fxHide.lt-md fxFlex.gt-md="60" fxFlex.md="50">
      <div fxLayout="row" fxLayoutAlign="center center">
        <div *ngIf="IssueAlert" class="inner welcomebox mat-elevation-z10" [class.lt-md]="SmallDisplay" [class.gt-sm]="!SmallDisplay">
            <mat-toolbar color="warn">
              <span>System Issue Alert</span>
            </mat-toolbar>
            <div>
              <span [innerHTML]="IssueAlert.AlertMessage | safeHTML"></span>
            </div>
        </div>
      </div>
    </div>
    <div fxFlex fxLayout="column" fxLayoutAlign="center center" fxLayoutAlign.lt-md="start center">
      <div class="topbox loginform" [class.lt-md]="SmallDisplay" [class.gt-sm]="!SmallDisplay">
        <form class="inner mat-elevation-z10" #f="ngForm" (ngSubmit)="onSubmit(f.value)" novalidate>
          <div fxFlexFill fxLayout="column" fxLayoutAlign="space-between stretch">
            <div fxLayout="column" fxLayoutAlign="start center">
              <mat-toolbar color="accent">
                <span>Login</span>
              </mat-toolbar>
              <mat-form-field>
                  <input matInput placeholder="Username" name="username" id="username" ngModel required autofocus />
                  <mat-icon matSuffix>person</mat-icon>
                  <mat-hint align="start">District staff: Please use firstname.lastname only</mat-hint>
              </mat-form-field>
              <mat-form-field>
                <input matInput placeholder="Password" type="password" name="password" id="password" ngModel />
                <mat-icon matSuffix mobiletap (doubleTap)="ShowImpersonation($event)">lock_outline</mat-icon>
              </mat-form-field>
              <div *ngIf="ShowImpersonationBox">
                <mat-checkbox matInput name="training" ngModel>Training Mode</mat-checkbox>
              </div>
              <mat-form-field *ngIf="ShowImpersonationBox">
                <input matInput placeholder="Impersonated Account/FocusID" type="password" name="impersonated" id="impersonated" ngModel />
                <mat-icon matSuffix>account_circle</mat-icon>
              </mat-form-field>
            </div>
            <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutWrap>
              <div>
                <button mat-raised-button type="submit" color="primary" [disabled]="f.invalid || LoginInProgress">Login</button>
              </div>
              <div>
                <a mat-button color="warn" href="https://password.mypolkschools.net/?from=DELTA">Need Password Help?</a>
              </div>
              <div>
                <button mat-raised-button color="accent" type="button" (click)="f.reset()">Reset</button>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="inner welcomebox mat-elevation-z10" [class.lt-md]="SmallDisplay" [class.gt-sm]="!SmallDisplay">
          <!-- Issue Alerts (if any) - Small width -->
          <mat-toolbar *ngIf="IssueAlert && SmallDisplay" color="warn">
            <span>System Issue Alert</span>
          </mat-toolbar>
          <div *ngIf="IssueAlert && SmallDisplay">
            <span [innerHTML]="IssueAlert.AlertMessage | safeHTML"></span>
          </div>
          <mat-toolbar color="warn">
              <span>Parents</span>
          </mat-toolbar>
          <div>
              <p>Please login to the <a href="https://focusk12.polk-fl.net/focus/" target="_blank">Focus Parent Portal</a> in order to access DELTA. You cannot use your Focus username and password to login to DELTA. Once you have logged into the Focus Parent Portal, access the "Additional Student Information" menu option and click the DELTA link to login to DELTA.</p>
          </div>
          <mat-toolbar color="primary">
            <span>District Students &amp; Staff</span>
          </mat-toolbar>
          <div>
            <p>Please use your Polk County Public Schools (PCPS) credentials to access the system. You do <em>not</em> need to provide the <em>@mypolkschools.net</em> (Students) or <em>@polk-fl.net</em> (Staff) portion of your email address as part of your username.</p>
          </div>
          <!-- <mat-toolbar color="primary">
            <span>College Advisors</span>
          </mat-toolbar>
          <div>
            <p>Use the DELTA account credentials emailed to you upon your account creation to access the system. If you wish to change your password, use the "Need Password Help?" link on the login form.</p>
          </div> -->
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/login/login.component.html